import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import ThemeProvider from 'utils/themeProvider';
import StateManager, { initialize } from "./state";
import { ApplicatonFormWeb } from './pages'

const container = document.getElementById('application-form');

if (container) {
  initialize()
  ReactDOM.render(
    <Provider store={StateManager.store}>
      <ThemeProvider>
        <ApplicatonFormWeb />
      </ThemeProvider>
    </Provider>,
    container,
  );
}
